// DES2 WS-14: the Knowledge page copy in this language (see ui/i18n/ns/knowledge-pages.ts).
import type { KnowledgePagesCopy } from '../ns/knowledge-pages';

const lv: KnowledgePagesCopy = {
  knowledgePage: 'Zināšanu lapa',
  knowledgePages: 'Zināšanu lapas',
  featureOffTitle: 'Zināšanu lapas šajā darbvietā nav iespējotas.',
  featureOffBody: 'Uzņēmuma konteksts un avoti joprojām ir sadaļā “Zināšanas”.',
  loadingPage: 'Ielādē lapu…',
  loadingSuggestion: 'Ielādē ieteikumu…',
  cancel: 'Atcelt',
  tryAgain: 'Mēģināt vēlreiz',
  everyoneIn: 'Visi {company} darbinieki',
  yourCompany: 'Jūsu uzņēmuma',
  revision: 'Redakcija {n}',
  openRevision: 'Atvērt redakciju {n}',
  pageCount: 'zero:lapu|one:lapa|other:lapas',
  topicCount: 'zero:tēmu|one:tēma|other:tēmas',
  sectionCount: 'zero:sadaļu|one:sadaļa|other:sadaļas',
  lineCount: 'zero:rindiņu|one:rindiņa|other:rindiņas',
  documentCount: 'zero:dokumentu|one:dokuments|other:dokumenti',
  changeCount: 'zero:izmaiņu|one:izmaiņa|other:izmaiņas',
  newPageCount: 'zero:jaunu lapu|one:jauna lapa|other:jaunas lapas',
  changedPageCount: 'zero:mainītu lapu|one:mainīta lapa|other:mainītas lapas',
  otherSectionCount: 'zero:citu sadaļu|one:cita sadaļa|other:citas sadaļas',
  characterCount: 'zero:rakstzīmju|one:rakstzīme|other:rakstzīmes',
  diffStats: 'Mainīts: {sections} · pievienots: {added} · noņemts: {removed}',
  diffMatchesBase: 'Ierosinātais teksts sakrīt ar bāzes redakciju.',
  diffIntroduction: 'Ievads',
  diffOtherUnchanged: 'Bez izmaiņām: {sections}.',
  timeJustNow: 'tikko',
  originImportedFrom: 'Importēts no {path}',
  originImportedFromCommit: 'Importēts no {path} @ {commit}',
  authorityApprovedInPoneva: 'Apstiprināts Poneva',
  authorityImported: 'Importēts',
  authorityInRepository: '{canonicality} repozitorijā',
  authorityVerified: 'pārbaudīts {date}',
  authorRepositoryImport: 'Imports no repozitorija',
  authorSuggestedInChat: 'Ieteikts tērzēšanā',
  authorSuggestedInChatWith: 'Ieteikts tērzēšanā ar {name}',
  authorSuggestedBy: 'Ieteica {name}',
  authorSuggestedByApp: 'Ieteica pievienota lietotne',
  authorSuggestedByColleague: 'Ieteica kolēģis',
  authorSuggestedByYou: 'Ieteicāt Jūs',
  authorSuggestedOnBehalf: 'Ieteica {app} lietotāja {name} vārdā',
  authorSuggestedByAppOnBehalf: 'Ieteica pievienota lietotne lietotāja {name} vārdā',
  authorSuggestedAndApproved: 'Ieteica un apstiprināja {name}',
  approverApprovedBy: 'apstiprināja {name}',
  approverAppliedBy: 'piemēroja {name}',
  kindCreatePage: 'Jauna lapa',
  kindUpdatePage: 'Ierosināts atjauninājums',
  kindArchivePage: 'Arhivēšana',
  statusConflict: 'Konflikts · lapa ir mainījusies',
  statusPending: 'Gaida pārskatīšanu',
  statusApproved: 'Apstiprināts',
  statusRejected: 'Noraidīts',
  statusWithdrawn: 'Atsaukts',
  statusSuperseded: 'Aizstāts',
  errRevisionConflict: 'Šī lapa mainījās, kamēr Jūs to pārskatījāt.',
  errProposalChanged:
    'Šis ieteikums mainījās, kamēr Jūs to pārskatījāt. Pirms lēmuma pieņemšanas pārskatiet jaunāko versiju.',
  errPublishRequired:
    'Tikai uzņēmuma publicētāji var apstiprināt zināšanu izmaiņas vai importēt lapas.',
  errProposalLimit:
    'Jūsu uzņēmumā jau ir 200 ieteikumu, kas gaida pārskatīšanu. Pirms ieteikt vēl, pārskatiet dažus no tiem.',
  errAuthorLimit:
    'Jums jau ir 50 ieteikumu, kas gaida pārskatīšanu. Pirms ieteikt vēl, pagaidiet, līdz par dažiem tiek pieņemts lēmums, vai atsauciet dažus.',
  errImportProposalLimit:
    'Šis imports pievienotu pārskatīšanai vairāk mainītu lapu, nekā ietilpst Jūsu uzņēmuma pārskatīšanas rindā (ne vairāk kā 200). Pieņemiet lēmumu par dažiem ieteikumiem sadaļā “Jāpārskata” un tad piemērojiet vēlreiz.',
  errImportChanged:
    'Šis nav tas imports, ko Jūs pārskatījāt. Atveriet to vēlreiz un pārskatiet pirms piemērošanas.',
  errImportItemNotFound: 'Šis dokuments vairs nav iekļauts importā.',
  errIdempotencyConflict:
    'Šis ieteikums jau tika nosūtīts ar citu saturu. Pārlādējiet un mēģiniet vēlreiz.',
  errImportHashMismatch:
    'Kāds šī momentuzņēmuma fails neatbilst reģistrētajai kontrolsummai. Izveidojiet momentuzņēmumu vēlreiz un mēģiniet atkārtoti.',
  errImportAlreadyApplied: 'Šis imports jau ir piemērots.',
  errImportDiscarded: 'Šis imports tika atmests. Izvēlieties momentuzņēmuma failu vēlreiz.',
  errImportDuplicateItem:
    'Šajā momentuzņēmumā viens un tas pats dokuments norādīts divreiz. Izveidojiet momentuzņēmumu vēlreiz.',
  errInvalidImport:
    'Poneva nevarēja pieņemt šo momentuzņēmumu. Izveidojiet to vēlreiz ar momentuzņēmuma skriptu un mēģiniet atkārtoti.',
  errInvalidInput: 'Poneva nevarēja pieņemt šos datus. Pārbaudiet laukus un mēģiniet vēlreiz.',
  errImportLimit:
    'Pārāk daudz importu ir sagatavoti, bet nav piemēroti. Pirms sagatavot nākamo, piemērojiet vai atmetiet dažus.',
  errPageTooLarge: 'Lapa ir lielāka par 256 KB. Sadaliet to mazākās lapās.',
  errTooManySections: 'Lapā ir vairāk nekā 2000 virsrakstu. Sadaliet to mazākās lapās.',
  errPageLimit: 'Jūsu uzņēmums ir sasniedzis 2000 zināšanu lapu ierobežojumu.',
  errCollectionLimit: 'Jūsu uzņēmums ir sasniedzis 100 tēmu ierobežojumu.',
  errProposalNotPending: 'Par šo ieteikumu jau ir pieņemts lēmums. Redzamais statuss ir aktuāls.',
  errRequesterRemoved:
    'Persona, kas to ieteica, vairs nav šajā uzņēmumā, tāpēc to nevar apstiprināt.',
  errRevisionAlreadyCurrent: 'Šī redakcija jau ir pašreizējā.',
  errPageArchived:
    'Šī lapa tika arhivēta, kamēr Jūs to pārskatījāt. Pirms lēmuma pieņemšanas pārskatiet ieteikumu vēlreiz.',
  errAlreadyArchived: 'Šī lapa jau ir arhivēta.',
  errProposalForbidden: 'To var atsaukt tikai persona, kas to ieteica.',
  errUnavailable: 'Zināšanu lapas pašlaik nav pieejamas.',
  errTimeout: 'Poneva atbildēja pārāk ilgi.',
  errItemTooLarge: '{path} ir lielāks par 256 KB. Sadaliet to mazākās lapās.',
  errItemTooManySections: 'Failā {path} ir vairāk nekā 2000 virsrakstu. Sadaliet to mazākās lapās.',
  errItemHashMismatch:
    '{path} neatbilst reģistrētajai kontrolsummai. Izveidojiet momentuzņēmumu vēlreiz un mēģiniet atkārtoti.',
  errNoLongerAvailable: 'Šis vienums Jums vairs nav pieejams.',
  errTooLargeToSend: 'Šis fails ir pārāk liels, lai to nosūtītu.',
  cardChecking: 'Pārbauda statusu…',
  cardNotAvailable: 'Nav pieejams',
  cardStatusUnavailable: 'Statuss nav pieejams',
  cardUnshowable: 'Šo ieteikto zināšanu atjauninājumu nevarēja parādīt.',
  cardEyebrow: 'Ieteikts zināšanu atjauninājums',
  cardLabel: 'Ieteikts zināšanu atjauninājums · {title}',
  cardMissing: 'Šis ieteikums Jums vairs nav pieejams.',
  cardUnknown:
    'Mēs nevarējām pārbaudīt, kādā stāvoklī ir šis ieteikums. Atveriet pārskatīšanu, lai redzētu tā statusu.',
  cardCheckAgain: 'Pārbaudīt vēlreiz',
  cardReview: 'Pārskatīt atjauninājumu',
  statusLineApproved: 'Apstiprinātā izpratne',
  readyCount: 'zero:gatavi meklēšanai|one:gatavs meklēšanai|other:gatavi meklēšanai',
  preparingCount: 'zero:tiek sagatavoti|one:tiek sagatavots|other:tiek sagatavoti',
  attentionCount: 'zero:jāpievērš uzmanība|one:jāpievērš uzmanība|other:jāpievērš uzmanība',
  topicsExplore: 'Izpētīt tēmu',
  topicsAllPages: 'Visas lapas',
  topicsOpenPages: 'Atvērt sadaļu “Lapas”',
  topicsEmpty:
    'Apstiprinātu lapu vēl nav. Lapās glabājas izvērsta uzņēmuma izpratne ar pilnu redakciju vēsturi.',
  reviewsTitle: 'Ieteiktie lapu atjauninājumi',
  reviewsTitleMine: 'Jūsu ieteiktie lapu atjauninājumi',
  reviewsIntro:
    'Katrs ieteikums ir pilnīga kandidātredakcija ar pamatojumu un pierādījumiem. Nekas nemainās, kamēr Jūs neapstiprināt tieši šo redakciju.',
  reviewsIntroMine:
    'Jūsu ieteikumi gaida šeit, līdz uzņēmuma publicētājs tos pārskatīs. Līdz tam lapas paliek nemainītas.',
  loadPagesFailed: 'Mēs nevarējām ielādēt zināšanu lapas.',
  loadProposalsFailed: 'Mēs nevarējām ielādēt ieteiktos lapu atjauninājumus.',
  loadMoreFailed: 'Mēs nevarējām ielādēt vairāk lapu.',
  otherPages: 'Citas lapas',
  loadTopicFailed: 'Mēs nevarējām ielādēt šo tēmu.',
  revisionShort: 'red. {n}',
  updatedOn: 'Atjaunināts {date}',
  emptyTitle: 'Zināšanu lapu vēl nav.',
  emptyBody:
    'Lapās glabājas Jūsu uzņēmuma apstiprinātā, izvērstā izpratne – virziens, lēmumi un darba paņēmieni – kopā ar katru redakciju. Importējiet no repozitorija momentuzņēmuma vai sāciet lapu tērzēšanā; publicētājs apstiprina katru lapu, pirms tā kļūst par uzņēmuma zināšanām.',
  importFromSnapshot: 'Importēt no repozitorija momentuzņēmuma',
  startInChat: 'Sākt lapu tērzēšanā',
  startInChatPrompt:
    'Palīdziet man izveidot zināšanu lapu mūsu uzņēmumam. Pajautājiet, kas tajā jāaptver, un neizdomājiet saturu. Tā paliek ieteikums, līdz uzņēmuma publicētājs to apstiprina.',
  loadingPages: 'Ielādē zināšanu lapas…',
  filterLabel: 'Filtrēt lapas pēc nosaukuma',
  filterPlaceholder: 'Filtrēt lapas',
  importButton: 'Importēt',
  showingTopic: 'Rāda tēmu {topic}',
  showAllTopics: 'Rādīt visas tēmas',
  loadingTopic: 'Ielādē šo tēmu…',
  noMatch: 'Neviena lapa neatbilst “{filter}”.',
  topicNoPages: 'Šajā tēmā vēl nav apstiprinātu lapu.',
  loading: 'Ielādē…',
  loadMore: 'Ielādēt vairāk lapu',
  metaApproved: 'apstiprināts {date}',
  metaRepositoryAuthoritative: 'noteicošais avots ir repozitorijs',
  loadPageFailed: 'Mēs nevarējām ielādēt šo lapu.',
  loadHistoryFailed: 'Mēs nevarējām ielādēt redakciju vēsturi.',
  outlineLabel: 'Lapas sadaļas',
  outlineToggle: 'Šajā lapā',
  loadingHistory: 'Ielādē redakciju vēsturi…',
  historyLabel: 'Redakciju vēsture',
  historyIntro:
    'Katra apstiprinātā redakcija tiek saglabāta. Atjaunojot agrāku redakciju, tiek izveidots ieteikums pārskatīšanai; vēlākās redakcijas nekad netiek dzēstas.',
  historyCurrent: 'Pašreizējā',
  historyViewing: 'Skatāt',
  historyView: 'Skatīt',
  historyViewAria: 'Skatīt redakciju {n}',
  restoreAria: 'Atjaunot kā ieteikumu: redakcija {n}',
  restoreCreating: 'Izveido ieteikumu…',
  restore: 'Atjaunot kā ieteikumu',
  restoreUnconfirmed:
    'Mēs nevarējām apstiprināt, ka ieteikums tika izveidots. Pirms mēģināt vēlreiz, pārbaudiet sadaļu “Jāpārskata”.',
  editTooLarge: 'Šī lapa ir lielāka par 256 KB. Pirms to ieteikt, sadaliet to mazākās lapās.',
  editConflict:
    'Šī lapa mainījās, kamēr Jūs to rediģējāt. Nokopējiet savu tekstu, atveriet jaunāko redakciju un iesakiet labojumu vēlreiz.',
  editUnconfirmed:
    'Mēs nevarējām apstiprināt, ka Jūsu ieteikums tika nosūtīts. Pirms sūtīt vēlreiz, pārbaudiet sadaļu “Jāpārskata”.',
  editHeading: 'Ieteikt labojumu',
  editIntro:
    'Jūs rediģējat redakciju {n}. Uzņēmuma publicētājs pārskata precīzās izmaiņas, pirms tās kļūst par redakciju {next}; līdz tam lapa paliek nemainīta.',
  editOutdated:
    'Kamēr Jūs rediģējāt, tika apstiprināta jaunāka redakcija. Nokopējiet savu tekstu un sāciet no jauna ar jaunāko redakciju, lai nezaudētu tajā veiktās izmaiņas.',
  editContentLabel: 'Lapas saturs (Markdown)',
  editReasonLabel: 'Kāpēc šīs izmaiņas?',
  editReasonPlaceholder: 'Kas mainījās un uz ko tas balstīts.',
  editSending: 'Sūta…',
  editSend: 'Nosūtīt pārskatīšanai',
  editDiscardConfirm: 'Atmest šo labojumu? Nekas no Jūsu veiktajām izmaiņām nav nosūtīts.',
  editNoChanges: 'Izmaiņu vēl nav.',
  editNeedsContent: 'Lapā jābūt saturam.',
  exportFailed: 'Mēs nevarējām eksportēt šo lapu. Mēģiniet vēlreiz.',
  askPagePrompt: 'Jautājums par zināšanu lapu “{title}” (redakcija {n}, {link}):',
  askPageSectionPrompt:
    'Jautājums par zināšanu lapu “{title}” § {section} (redakcija {n}, {link}):',
  pageMissingTitle: 'Šī lapa nav pieejama.',
  pageMissingBody: 'Iespējams, tā ir arhivēta vai Jums vairs nav piekļuves šī uzņēmuma zināšanām.',
  pageArchived: 'Arhivēta',
  viewingRevisionCurrent: 'Jūs skatāt redakciju {n}; pašreizējā redakcija ir {current}.',
  viewingRevisionOld: 'Jūs skatāt redakciju {n}. Tā nav pašreizējā redakcija.',
  openCurrent: 'Atvērt pašreizējo',
  archivedBanner:
    'Šī lapa ir arhivēta. Tā vairs netiek izmantota atbildēs; tās vēsture tiek saglabāta.',
  pageViewsLabel: 'Lapas skati',
  tabRead: 'Lasīt',
  tabHistory: 'Vēsture',
  unknownSection: 'Saistītā sadaļa nav šajā redakcijā. Tiek rādīta visa lapa.',
  askAboutPage: 'Jautāt par šo lapu',
  exporting: 'Eksportē…',
  exportMarkdown: 'Eksportēt Markdown',
  loadSuggestionFailed: 'Mēs nevarējām ielādēt šo ieteikumu.',
  evidenceSource: 'Avots',
  evidenceFact: 'Uzņēmuma konteksts',
  evidenceResult: 'Saglabāts darbs',
  evidenceUrl: 'Tīmekļa lapa',
  evidenceDecision: 'Lēmums',
  evidenceReference: 'Atsauce',
  evidenceOpenPage: 'Atvērt zināšanu lapu',
  evidenceOpenSource: 'Atvērt avotu',
  evidenceOpenFact: 'Atvērt uzņēmuma kontekstu',
  evidenceOpenResult: 'Atvērt saglabāto darbu',
  evidenceOpenUrl: 'Atvērt tīmekļa lapu',
  evidenceOpenDecision: 'Atvērt lēmumu',
  evidenceOpenReference: 'Atvērt atsauci',
  evidenceDecisionNote: 'Reģistrēts lēmums. Poneva nav nekā, ko atvērt.',
  evidenceFactGone: 'Šis uzņēmuma konteksts vairs nav saglabāts.',
  evidencePageNoRevision: 'Šai lapai nav apstiprinātas redakcijas, ko atvērt.',
  evidencePrivateExcerpt: 'Privāti pierādījumi – kopīgots tikai iepriekš redzamais fragments.',
  evidencePrivate: 'Privāti pierādījumi – to saturs ar Jums netika kopīgots.',
  evidenceHeading: 'Pierādījumi',
  evidenceNone: 'Pierādījumi nav pievienoti. Izvērtējiet iepriekš norādīto pamatojumu atsevišķi.',
  changeAdded: 'Pievienots',
  changeRemoved: 'Noņemts',
  changeChanged: 'Mainīts',
  changeUnchanged: 'Nemainīts',
  moreLineCount: 'zero:papildu rindiņu|one:papildu rindiņa|other:papildu rindiņas',
  moreUnchangedLineCount:
    'zero:papildu nemainītu rindiņu|one:papildu nemainīta rindiņa|other:papildu nemainītas rindiņas',
  unchangedLineCount: 'zero:nemainītu rindiņu|one:nemainīta rindiņa|other:nemainītas rindiņas',
  skipAdded: '{lines} – skatiet pilnajā redakcijā',
  skipRemoved: 'Noņemts: {lines}',
  cutUnchanged: 'Netiek rādīts: {lines}',
  cutChanged: 'Netiek rādīts: {lines} ({changes}). Pārbaudiet tās pilnajā redakcijā.',
  cutAddedRemoved: 'pievienots {added}, noņemts {removed}',
  cutAdded: 'pievienots {added}',
  cutRemoved: 'noņemts {removed}',
  lineAddedSr: 'Pievienots:',
  lineRemovedSr: 'Noņemts:',
  noLinesAdded: 'Jauna sadaļa. Tās teksts ir pilnajā redakcijā zemāk.',
  noLinesRemoved: 'Šī sadaļa tiktu noņemta no lapas.',
  noLinesChanged: 'Šī sadaļa mainās. Tās teksts ir pilnajā redakcijā zemāk.',
  diffHeading: 'Izmaiņas',
  outcomeArchived: 'Arhivēts.',
  outcomeArchivedBody:
    'Lapa “{title}” vairs netiek izmantota atbildēs un ir izņemta no lapu saraksta. Tās redakcijas, šis ieteikums un lēmums paliek lapas vēsturē.',
  openArchivedPage: 'Atvērt arhivēto lapu',
  outcomeApproved: 'Apstiprināts.',
  outcomeApprovedRevision: 'Redakcija {n} tagad ir lapas “{title}” apstiprinātā versija.',
  outcomeApprovedPlain: 'Šis ieteikums tika apstiprināts.',
  outcomeRestored: 'Lapa ir atpakaļ lapu sarakstā un atkal tiek izmantota atbildēs.',
  outcomeKept: 'Ieteikums, lēmums un visas agrākās redakcijas paliek lapas vēsturē.',
  openPage: 'Atvērt lapu',
  outcomeDismissed: 'Noraidīts.',
  outcomeWithdrawn: 'Atsaukts.',
  outcomeSuperseded: 'Aizstāts.',
  outcomeSupersededBody:
    'Jaunāka redakcija, ieteikums vai imports no repozitorija padarīja šo ieteikumu novecojušu. Pats par sevi tas neko nemainīja.',
  outcomeUnchanged: 'Lapa paliek nemainīta.',
  approveNewPage: 'Apstiprināt jaunu lapu',
  approveArchive: 'Apstiprināt arhivēšanu',
  approveRestoreRevision: 'Atjaunot un apstiprināt redakciju {n}',
  approveRevision: 'Apstiprināt redakciju {n}',
  approveArchiveNote: 'Apstiprinot šī lapa tiks arhivēta visiem {company} darbiniekiem.',
  approvePublishNote: 'Apstiprinot šī redakcija tiks publicēta visiem {company} darbiniekiem.',
  approvePublishEvidenceNote:
    'Apstiprinot šī redakcija un iepriekš redzamie pierādījumu fragmenti tiks publicēti visiem {company} darbiniekiem.',
  archivedTitle: 'Šī lapa ir arhivēta.',
  alreadyArchivedBody: 'Apstiprināšana neko nemainītu, tāpēc šo ieteikumu var tikai noraidīt.',
  archivedRestoreBody:
    'Apstiprinot lapa tiks atjaunota: tā ar šo redakciju atgriezīsies lapu sarakstā, meklēšanā un atbildēs.',
  staleRevisionAction: 'Salīdzināt ar jaunāko versiju',
  staleProposalTitle: 'Šis ieteikums mainījās, kamēr Jūs to pārskatījāt.',
  staleProposalAction: 'Pārskatīt jaunāko versiju',
  staleArchivedTitle:
    'Šī lapa tika arhivēta, kamēr Jūs to pārskatījāt. Apstiprinot šo ieteikumu, tā tiktu atjaunota.',
  staleArchivedAction: 'Pārskatīt vēlreiz',
  suggestionMissingTitle: 'Šis ieteikums nav pieejams.',
  suggestionMissingBody:
    'Iespējams, tas ir atsaukts vai pieder kādam citam un nav nosūtīts uzņēmuma pārskatīšanai.',
  decideUnconfirmed:
    'Mēs nevarējām apstiprināt Jūsu lēmumu. Redzamais statuss ir jaunākais no Poneva; pārbaudiet to, pirms mēģināt vēlreiz.',
  decideFailed: 'Mēs nevarējām saglabāt Jūsu lēmumu.',
  discussPrompt: 'Palīdziet man uzlabot ieteikto zināšanu atjauninājumu lapai “{title}” ({link}).',
  conflictBody:
    'Šis ieteikums tika rakstīts, balstoties uz redakciju {base}; pašreizējā redakcija ir {current}. Apstiprinot to, šīs izmaiņas tiktu pārrakstītas, tāpēc pašreizējā veidā to nevar apstiprināt.',
  conflictBodyPlain:
    'Šis ieteikums tika rakstīts, balstoties uz agrāku redakciju, tāpēc pašreizējā veidā to nevar apstiprināt.',
  openLatest: 'Atvērt jaunāko versiju',
  reworkInChat: 'Pārstrādāt tērzēšanā',
  factReason: 'Pamatojums',
  factNoReason: 'Pamatojums netika norādīts.',
  factAudience: 'Auditorija',
  factRevision: 'Redakcija',
  revisionNew: 'Jauna lapa, 1. redakcija',
  revisionArchiveAfter: 'Arhivēt pēc redakcijas {n}',
  revisionWrittenAgainst:
    'Rakstīts, balstoties uz redakciju {base}; pašreizējā redakcija ir {current}',
  revisionCurrentToProposed: 'Pašreizējā redakcija {base} → ierosinātā redakcija {next}',
  revisionProposed: 'Ierosinātā redakcija {next}',
  proposedPage: 'Ierosinātā lapa',
  archivingHeading: 'Ko nozīmē arhivēšana',
  archivingBody:
    'Lapa vairs netiek izmantota atbildēs un tiek izņemta no lapu saraksta. Tās redakcijas un šis lēmums tiek saglabāti.',
  noComparison: 'Šim ieteikumam sadaļu salīdzinājums nav pieejams.',
  showComplete: 'Rādīt pilno redakciju',
  approving: 'Apstiprina…',
  dismissing: 'Noraida…',
  dismiss: 'Noraidīt',
  withdrawing: 'Atsauc…',
  withdraw: 'Atsaukt',
  editInChat: 'Rediģēt tērzēšanā',
  waitingForPublisher: 'Gaida, līdz uzņēmuma publicētājs to pārskatīs.',
  snapshotTooLarge: 'Šis momentuzņēmums ir lielāks par 8 MB. Izveidojiet to ar mazāk dokumentiem.',
  snapshotNotSnapshot:
    'Šis fails nav zināšanu momentuzņēmums. Izvēlieties JSON failu, ko izveidoja momentuzņēmuma skripts.',
  snapshotEmpty: 'Šajā momentuzņēmumā nav dokumentu.',
  readDocumentFailed: 'Mēs nevarējām nolasīt šo dokumentu. Mēģiniet vēlreiz.',
  readingDocument: 'Nolasa dokumentu…',
  hideText: 'Paslēpt tekstu',
  readText: 'Lasīt tekstu',
  textOf: '“{title}” teksts',
  gitSnapshot: 'Git momentuzņēmums {commit}',
  repositorySnapshot: 'Repozitorija momentuzņēmums',
  importNewHeading: '{pages} · apstiprina, kad piemērojat',
  importNewNote:
    'Katra tiks publicēta kā apstiprināta lapa visiem {company} darbiniekiem bez papildu pārskatīšanas. Pirms piemērošanas izlasiet katru.',
  importChangedHeading: '{pages} · nosūta pārskatīšanai',
  importChangedNote:
    'Katra kļūst par ieteiktu atjauninājumu. Tās lapa mainās tikai tad, kad publicētājs to apstiprina sadaļā “Jāpārskata”, kur redzams, kas mainījās.',
  unchangedDocumentCount:
    'zero:nemainītu dokumentu|one:nemainīts dokuments|other:nemainīti dokumenti',
  unchangedNote: 'Tie jau atbilst savām apstiprinātajām lapām. Tiem nekas netiek ierakstīts.',
  stagedHeading: 'Sagatavots, bet nav piemērots',
  excludedSummary: 'Šajā momentuzņēmumā nav iekļauts: {documents}',
  countsLine: '{newPages} · pārskatīšanai: {changedPages} · bez izmaiņām: {unchanged}',
  importAlreadyDiscarded: 'Šis imports jau ir atmests.',
  confirmLabel: 'Apstiprināt importu',
  unchangedKeepCount:
    'zero:nemainītu dokumentu saglabā savas lapas|one:nemainīts dokuments saglabā savu lapu|other:nemainīti dokumenti saglabā savas lapas',
  confirmBody:
    'Piemērot šo importu visiem {company} darbiniekiem? Kā 1. redakcija tiks apstiprināts: {newPages}; pārskatīšanu gaidīs: {changedPages}; un {unchanged}. Agrākie importa ieteikumi šīm lapām tiek atsaukti.',
  applying: 'Piemēro…',
  applyImport: 'Piemērot importu',
  chooseAnother: 'Izvēlēties citu failu',
  allCurrent: 'Viss šajā momentuzņēmumā jau ir aktuāls.',
  importApplied: 'Imports piemērots.',
  appliedSummary: 'Izveidots: {pages} · gaida pārskatīšanu: {changes} · bez izmaiņām: {unchanged}.',
  appliedIndexing:
    'Jaunās lapas būs meklējamas tērzēšanā, tiklīdz beigsies indeksēšana. Progress redzams sadaļā “Avotu sagatavošana”.',
  openPages: 'Atvērt lapas',
  reviewChanges: 'Pārskatīt izmaiņas ({changes})',
  checkIndexing: 'Pārbaudīt indeksēšanas progresu',
  sendSnapshotFailed: 'Mēs nevarējām nosūtīt šo momentuzņēmumu. Mēģiniet vēlreiz.',
  openStagedFailed: 'Mēs nevarējām atvērt šo sagatavoto importu.',
  applyUnconfirmed:
    'Mēs nevarējām apstiprināt, vai imports tika piemērots. Pirms mēģināt vēlreiz, pārbaudiet sadaļu “Lapas”.',
  applyFailed: 'Mēs nevarējām piemērot šo importu.',
  importHeading: 'Importēt lapas no repozitorija',
  backToPages: 'Atpakaļ uz lapām',
  importLead:
    'Izveidojiet momentuzņēmumu ar {command}, tad izvēlieties failu. Pirms kaut kas tiek saglabāts, Jūs redzēsiet katru dokumentu un to, ko tas mainītu.',
  snapshotFileLabel: 'Zināšanu momentuzņēmuma fails',
  readingSnapshot: 'Nolasa momentuzņēmumu…',
  openingStaged: 'Atver sagatavoto importu…',
  chooseSnapshot: 'Izvēlēties momentuzņēmuma failu',
  factOrigin: 'Izcelsme',
  factContents: 'Saturs',
  importOnlyListed: 'Tiek importēti tikai šeit norādītie dokumenti.',
  importRepositoryAuthoritative:
    'Noteicošais avots joprojām ir repozitorijs; mainītie dokumenti kļūst par ieteikumiem pārskatīšanai.',
  overviewReviewChanges: 'Pārskatīt izmaiņas',
  overviewConnectAgents: 'Pievienot ārējos aģentus',
  overviewEyebrow: 'Kopīga izpratne',
  overviewTitle: '{company} kontekstā.',
  overviewLeadFallback:
    'Jūsu uzņēmuma zināšanas sākas ar kontekstu, ko Jūs kopīgojat. Veidojiet izpratni par savu uzņēmējdarbību kopā.',
  overviewBody:
    'Uzņēmuma konteksts un avotu materiāli dod Poneva sākumpunktu, nevis visu, ko var zināt par {company}. Turpiniet veidot šo izpratni, uzņēmējdarbībai attīstoties.',
  overviewAskPrompt: 'Ko Jūs zināt par mūsu uzņēmumu un ko būtu noderīgi pievienot?',
  overviewAsk: 'Jautāt par {company}',
  overviewAddSources: 'Pievienot avotus',
  contextEyebrow: 'Kas piešķir atbildēm kontekstu',
  contextTitle: 'Uzņēmējdarbība aiz jautājuma.',
  contextBody:
    'Tīmekļa vietņu avoti izskaidro publisko uzņēmējdarbību. Uzņēmuma piezīmes papildina Jūsu terminoloģiju, prioritātes un darba veidu.',
  contextPrompt:
    'Palīdziet man precizēt uzņēmuma prioritātes un darba paradumus, kas mums jāatceras.',
  contextAction: 'Veidot mūsu izpratni',
  learnEyebrow: 'Vieta mācībām',
  learnTitle: 'Sāciet ar to, kas ir svarīgs tālāk.',
  learnBody:
    'Pievienojiet avotu materiālus vai precizējiet, kā strādā Jūsu uzņēmums. Poneva var ieteikt ilgstošas izmaiņas, ko Jūs pārskatīsiet.',
  learnPrompt:
    'Ņemot vērā mūsu esošās uzņēmuma zināšanas, kādas svarīgas informācijas trūkst darbam, ko vēlamies paveikt?',
  learnAction: 'Apspriest, kas būtu noderīgi',
  canvasEmptyTitle: 'Pat neliels konteksts dod daudz.',
  canvasEmptyBody:
    'Jūsu uzņēmuma profils ir sākumpunkts. Pievienojiet avotu materiālus un pārskatītas piezīmes, lai palīdzētu Poneva saprast Jūsu darbu.',
  pageEyebrow: '{company} darbvieta',
  pageTitle: 'Uzņēmuma zināšanas',
  pageDescription: 'Avoti un izpratne, uz kuriem balstās Poneva darbs.',
  tabOverview: 'Pārskats',
  tabPages: 'Lapas',
  tabSources: 'Avoti',
  tabReview: 'Jāpārskata',
  proposalApproved: 'Apstiprināts uzņēmuma konteksts',
  proposalDismissed: 'Noraidīts ieteikums',
  proposalRemoval: 'Ierosināta noņemšana',
  proposalCorrection: 'Ierosināts labojums',
  proposalContext: 'Ierosināts uzņēmuma konteksts',
  proposalCurrent: 'Pašreizējā izpratne',
  proposalFactGone:
    'Saglabātais fakts vairs nav pieejams. Pirms pārskatāt šo noņemšanu, atsvaidziniet uzņēmuma zināšanas.',
  proposalReviewFallback: 'Pārskatiet ierosināto uzņēmuma kontekstu.',
  proposalNotSaved: 'Vēl nav saglabāts. Sākotnējie avoti paliek nemainīti.',
  proposalWaiting: 'Gaida pārskatīšanu · lēmumu pieņem uzņēmuma publicētājs savā sadaļā “Iesūtne”',
  proposalSaving: 'Saglabā…',
  proposalApproveRemoval: 'Apstiprināt noņemšanu',
  proposalApproveClarification: 'Apstiprināt precizējumu',
  factLabel: 'Uzņēmuma fakts',
  factEyebrow: 'Fakts · Visi {company} darbinieki',
  factSuggestCorrection: 'Ieteikt labojumu',
  factAskPrompt: 'Palīdziet man saprast vai precizēt šo saglabāto uzņēmuma kontekstu: “{content}”',
  factAsk: 'Jautāt par to',
  companyContextHeading: 'Uzņēmuma konteksts',
  companyContextPrompt:
    'Es vēlētos precizēt mūsu uzņēmuma zināšanas. Palīdziet man pārskatīt, ko mēs zinām, un ierosināt atjauninājumu.',
  companyContextEmpty:
    'Vēl nav apstiprinātu piezīmju. Sāciet sarunu par savu uzņēmumu vai pievienojiet avotu materiālus tālāk.',
  refineInChat: 'Uzlabot tērzēšanā',
  reviewPanelLabel: 'Pārskatāmās zināšanu izmaiņas',
  suggestedUpdatesHeading: 'Ieteiktie atjauninājumi',
  suggestedUpdatesIntro:
    'Ieteikumi no Jūsu sarunām. Jūs izlemjat, kas kļūst par Jūsu uzņēmuma ilgstošo zināšanu daļu.',
  reviewEmptyTitle: 'Nekas negaida Jūsu pārskatīšanu.',
  reviewEmptyBody:
    'Kad Poneva ieteiks izmaiņas Jūsu uzņēmuma zināšanās, tās atradīsiet šeit. Ilgstošām izmaiņām vienmēr nepieciešams Jūsu apstiprinājums.',
  reviewEmptyPrompt:
    'Palīdziet man pārskatīt mūsu uzņēmuma zināšanas un iesakiet, ko būtu noderīgi precizēt tālāk.',
  inclusionPendingApproval: 'Iekļaušanas zināšanās izmaiņas nosūtītas apstiprināšanai.',
  sourcesFileIncluded: 'Fails iekļauts zināšanu meklēšanā tā pašreizējai auditorijai.',
  sourcesAddFailed: 'Nevarēja pievienot šo avotu.',
  sourcesHeading: 'Materiāli, uz kuriem balstās atbildes.',
  sourcesIntro:
    'Poneva meklē visos avotu materiālos, ne tikai pārskatā. Saglabājiet oriģinālus, skatiet, kas ir gatavs, un izvēlieties, kas veido Jūsu atbildes.',
  addSourceHeading: 'Pievienojiet sava uzņēmuma materiālus',
  addSourceIntro:
    'Augšupielādētie avoti paliek privāti Jūsu sadaļā “Bibliotēka” un tiek izmantoti tikai Jūsu atbildēs. Izvēlieties “Kopīgot”, kad vēlaties tos padarīt pieejamus kolēģiem.',
  uploadSource: 'Augšupielādēt avotu',
  addSourcePrompt:
    'Palīdziet man pievienot uzņēmuma paziņojumu kā kopīgu iekšēju avotu. Pajautājiet, ko es vēlos ierakstīt; neizdomājiet nekādu saturu. Ilgstošām izmaiņām uzņēmuma izpratnē joprojām nepieciešams mans apstiprinājums.',
  addThroughChat: 'Pievienot tērzēšanā',
  addingSource: 'Pievieno…',
  addToKnowledge: 'Pievienot zināšanām',
  uploadFormats: 'TXT, Markdown, CSV un JSON · Līdz 5 MB katram failam',
  sourceExcluded: 'Izslēgts no atbildēm',
  sourcePreparationFailed: 'Sagatavošana neizdevās',
  sourcePreparing: 'Tiek sagatavots meklēšanai',
  sourceWaiting: 'Gaida sagatavošanu',
  sourceReadinessUnknown: 'Gatavības statuss nav pieejams',
  sourceRetryQueued:
    'Sagatavošana ievietota rindā. Gatavības statuss tiks atjaunināts, kad tā būs pabeigta.',
  sourceIncludedNotice: 'Avots iekļauts. Poneva to sagatavos meklēšanai.',
  sourceExcludedNotice: 'Izslēgts no atbildēm. Sākotnējais avots tiek saglabāts.',
  sourceUpdateFailed: 'Šo avotu nevarēja atjaunināt.',
  sourceOriginalMaterial: 'Sākotnējais avota materiāls',
  sourceDiscuss: 'Apspriest tērzēšanā',
  sourceDiscussPrompt: 'Palīdziet man saprast vai precizēt “{title}”.',
  sourceExclude: 'Izslēgt no atbildēm',
  sourceInclude: 'Iekļaut atbildēs',
  sourcesLoadFailed: 'Mēs nevarējām ielādēt Jūsu avotus.',
  sourceLibraryLabel: 'Uzņēmuma avotu bibliotēka',
  sourceListCaption: 'Sākotnējie avoti · iekļautie un izslēgtie',
  sourceSearchLabel: 'Meklēt uzņēmuma avotos',
  sourceSearchPlaceholder: 'Meklējiet savos avotos…',
  sourcesFinding: 'Meklē Jūsu avotus…',
  sourcePagesLabel: 'Avotu lapošana',
  sourceRange: '{from}–{to} no {count}',
  sourceCount: 'zero:avotu|one:avots|other:avoti',
  sourcePrevious: 'Iepriekšējais',
  sourceNext: 'Tālāk',
  sourceNoMatchTitle: 'Nav atbilstošu avotu.',
  sourceNoMatchBody: 'Izmēģiniet citu frāzi vai avota nosaukumu.',
  sourceEmptyTitle: 'Dodiet saviem jautājumiem stabilāku sākumpunktu.',
  sourceEmptyBody:
    'Pievienojiet uzņēmuma dokumentus, produktu datus vai darba piezīmes. Poneva var izmantot visus avotu materiālus sarunās un Skills.',
  indexCheckFailed: 'Mēs nevarējām pārbaudīt avotu sagatavošanu.',
  indexRetryQueued:
    'Neizdevušies zināšanu ieraksti ievietoti sagatavošanas rindā. Jūsu avotu materiāli nav mainīti.',
  indexQueueFailed: 'Mēs nevarējām ievietot sagatavošanu rindā. Mēģiniet vēlreiz.',
  indexPreparing: 'Sagatavo jaunas zināšanas Jūsu sarunām…',
  indexAttention: 'Dažām zināšanām jāpievērš uzmanība.',
  queuing: 'Ievieto rindā…',
  retryPreparation: 'Sagatavot vēlreiz',
  sourceKindStatement: 'Uzņēmuma paziņojums',
  sourceKindWebsite: 'Tīmekļa vietne',
  sourceKindDocument: 'Dokuments',
  factAnswers: 'zero:atbilžu|one:atbilde|other:atbildes',
  factUsedThisWeek: 'Izmantots šonedēļ: {answers}',
  factLastUsed: 'pēdējoreiz izmantots: {when}',
  factToday: 'šodien',
  factYesterday: 'vakar',
  factImpact: 'Šīs izmaiņas ietekmē faktu, kas izmantots šonedēļ ({answers}).',
  factCorrectionAbout: 'Par šo uzņēmuma faktu: “{content}” ({link})',
  factCorrectionOutdated: 'Tas vairs nav aktuāls:',
  sourceCanvasRecorded: 'Ierakstīti avotu materiāli',
  sourceCanvasNotIncluded:
    'Nav iekļauts uzņēmuma zināšanās. Oriģināls tiek saglabāts uzziņai, un to joprojām var izmantot konkrētā sarunā.',
  sourceCanvasOpenOriginal: 'Atvērt sākotnējo avotu',
  sourceCanvasUnavailable: 'Avota saturs nav pieejams.',
  sourceCanvasDiscussPrompt: 'Palīdziet man izprast vai precizēt “{title}”.',
  sourceCanvasDiscuss: 'Apspriest šo avotu',
  sourceCanvasCorrectionNote:
    'Labojums kļūst par ieteikto uzņēmuma kontekstu. Ierakstītais avots paliek nemainīts.',
  contextCanvasEyebrow: 'Pieejamais uzņēmuma konteksts',
  contextCanvasTitle: 'Zināšanas, uz kurām balstās šī saruna.',
  contextCanvasBody:
    'Apstiprinātā izpratne un Jūsu uzņēmuma pievienotie avotu materiāli. Pieejami tērzēšanā un Skills.',
  contextCanvasOpen: 'Atvērt “Zināšanas”',
};

export default lv;
